import('./main');
import('@fsa/app-info');
